import { ApiRequest, RequestMethod } from "../../request";
import { XpHistory } from "../../../model/Dto/XpHistory";

type GetXpHistoryResponse = {
    success: boolean;
    xpHistory: XpHistory[];
};

export async function getFighterXpHistory(id: string): Promise<GetXpHistoryResponse> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl(`/api/fighter/${id}/xp`);

    try {
        const response: any = await apiRequest.send();

        if (response.status === 200) {
            const xpHistory: XpHistory[] = Array.isArray(response.data)
                ? response.data.map((item: any) => ({
                    eventId: item.eventId ?? undefined,
                    xp: item.xp,
                    description: item.description,
                    date: item.date as string,
                }))
                : [];

            return { success: true, xpHistory };
        }

        return { success: false, xpHistory: [] };
    } catch {
        return { success: false, xpHistory: [] };
    }
}
